import { render, staticRenderFns } from "./Mains.vue?vue&type=template&id=68b2425a&scoped=true&"
import script from "./Mains.vue?vue&type=script&lang=js&"
export * from "./Mains.vue?vue&type=script&lang=js&"
import style0 from "./Mains.vue?vue&type=style&index=0&id=68b2425a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b2425a",
  null
  
)

export default component.exports